import { FC } from 'react';
import { RiFilePdf2Line } from 'react-icons/ri';

interface IProps {
  onClick: () => void;
  btnText: string;
}

const DownloadButton: FC<IProps> = ({ onClick, btnText }) => {
  return (
    <div className='comm-btn__area'>
      <button
        className="btn-basic crimson"
        onClick={onClick}
      >
        <span style={{ display: 'inline-block', transform: 'translateY(-1px)'  }}><RiFilePdf2Line /></span>
        <span className="ml-1">{btnText?btnText:'DOWNLOAD'}</span>
      </button>
    </div>
  )
}

export default DownloadButton;
